"use strict";

exports.__esModule = true;
exports.XmlValidation = void 0;
/*
 * COPYRIGHT 2020,2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
var XmlValidation = /*#__PURE__*/function () {
  function XmlValidation() {
    if ((this instanceof XmlValidation ? this.constructor : void 0) === XmlValidation) {
      throw new TypeError("Cannot construct abstract class XmlValidation directly");
    }
  }
  var _proto = XmlValidation.prototype;
  _proto.isValid = function isValid() {
    return true;
  };
  return XmlValidation;
}();
exports.XmlValidation = XmlValidation;